import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Select,DatePicker,Switch    } from 'antd';


import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import person from '../../assets/images/icon/person.png';
import correct from '../../assets/images/icon/correct.png';
import wrong from '../../assets/images/icon/wrong.png';
import edit from '../../assets/images/icon/edit.png';

const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

function onChange_(checked) {
  console.log(`switch to ${checked}`);
}



class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			school_list: '',
			is_parent: 1,
			name: '',
			url: '',
			loading: false,
  		    iconLoading: false,
		}
		this.onChange_ = this.onChange_.bind(this);	
		this.goBack = this.goBack.bind(this);	
		
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],id : this.props.match.params.id, });
		this.checkData()
		}
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			 this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			let program_id = this.props.match.params.id;
			var app = {user_id : user_id,id:program_id}
			getData('erp/cctv_details',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							name: result['data'][0]['name'],
							url: result['data'][0]['url'],
							is_parent: result['data'][0]['is_parent'],
						});
						
						document.getElementById("name").value = result['data'][0]['name'];
						document.getElementById("url").value = result['data'][0]['url'];
						document.getElementById("is_parent").value = result['data'][0]['is_parent'];
						
						
						
					}else{
						this.setState({
							school_list: [],
							
						});
					}
				}
			});
	}
  }
  
  handleSubmit=(e)=>{
    e.preventDefault();
	if(localStorage.getItem('schoolData')){
    this.setState({ loading: true });
      getData('erp/cctv_edit',this.state).then((result) => {
      if(result.status==400){
           message.config({ top: 150});
			message.error('Please Insert All Field',2);
			this.setState({ loading: false });
          }
          if(result.status==200){
            message.config({ top: 150});
            message.success('Cctv Updated',2);
             
              window.location.href = '/cctv/index/';
              //this.checkdata();

          }
      });
	  }else{
		message.error('Please Login',2);	
	  }

  }
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
	
	onChange_(checked) {
		if(checked == true){
			var is_parent = 1;
		}else{
			var is_parent = 0;
		}
	  
	 this.setState({ is_parent : is_parent });
	  
	}
	
	goBack(){
		window.location.href = '/cctv/index';
	}
	render()

	{
	
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img"><Tooltip placement="right" title="Audio"><img src={music} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Pdf"><img src={pdf_} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Image"><img src={image} class="" alt="image" /></Tooltip></p>
						
					  </div>
					);
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 
			<div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="container">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40">
                     
					 <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Edit CCTV Access</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                           <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
						   <li class="breadcrumb-item"><a href="/cctv/index">CCTV Access</a>
                           </li>
                           <li class="breadcrumb-item active">Edit CCTV Access
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
        
		
		<div class="col s12 m12 ex-padd">    
            <div class="container view-Profile view-Profile-mobile">
			   <div class="col s12 m12 mb-20 no-padd">
                  <section class="section food cctv no-padd">
					<div class="children mb-20  iq-card2 flow-root">
                     
						<div class="bb d-flex">
						  <div class="col m12 pt-10">
								<div class="col m12 s12 mb-10">
									<label>CCTV Url</label>
									<input type="text" name="url" id="url" onChange={this.handleSizeChange} />
								</div>	
								<div class="col m6 s12 mb-10">
									<label>Display Name</label>
									<input type="text" ame="name" id="name" onChange={this.handleSizeChange}  />
								</div>	
								<div class="col m4  mb-10 mt-20">
									<label class="mr-10">Access For Parents</label>
									<Switch defaultChecked name="is_parent" id="is_parent" onChange={this.onChange_} />
								</div>	
								
								
						  </div>
						</div>  
					</div> 
					
					
									
					
					
					<div class="meal mt-20 mb-20 pb-20 bb center">
						 <Button className="cancel-btn" onClick={this.goBack}>Back</Button>
						 <Button className="snd-btn" onClick={this.handleSubmit} loading={this.state.loading}>Save</Button>
					</div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
